import { Stack } from "@fluentui/react";
import {
  FluentProvider,
  ToggleButton,
  webLightTheme,
} from "@fluentui/react-components";
import { CustomToggleButtonGroupProps } from "./Interfaces/CustomToggleButtonGroupProps.interfaces";

export const CustomToggleButtonGroup = ({
  items,
  selected,
  setSelected,
  stackProps,
  toggleButtonProps,
  disabledItems = [],
}: CustomToggleButtonGroupProps) => (
  <FluentProvider theme={webLightTheme}>
    <Stack horizontal wrap {...stackProps}>
      {items.map((item) => (
        <ToggleButton
          appearance={item === selected ? "primary" : undefined}
          checked={item === selected}
          key={item}
          onClick={() => setSelected(item)}
          shape="circular"
          disabled={disabledItems.includes(item)}
          {...toggleButtonProps}
        >
          {item}
        </ToggleButton>
      ))}
    </Stack>
  </FluentProvider>
);
